import { TFunction } from "i18next";
import { UserDTO } from "../domain/models/dto/UserDTO";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";

export const usersSearchFiltersFields: Fields<UserDTO> = {
    email: {
        min: 1,
        max: 128,
        placeholderKey: "auth.fields.email",
        type: "text",
        optional: true,
        initial: "",
        patternErrorKey: "errors.validation.invalidOption",
    },
    roleId: {
        min: 0,
        max: 10,
        placeholderKey: "console.common.roleId",
        type: "number",
        optional: true,
        initial: "",
    },
    firstName: {
        min: 1,
        max: 50,
        placeholderKey: "auth.fields.firstName",
        type: "text",
        optional: true,
        initial: "",
    },
    lastName: {
        min: 1,
        max: 50,
        placeholderKey: "auth.fields.lastName",
        type: "text",
        optional: true,
        initial: "",
    },
    middleName: {
        min: 1,
        max: 50,
        placeholderKey: "auth.fields.middleName",
        type: "text",
        optional: true,
        initial: "",
    },
    phone: {
        min: 13,
        max: 20,
        placeholderKey: "auth.fields.phone",
        type: "text",
        optional: true,
        initial: "",
        patternErrorKey: "errors.validation.invalidPhone",
    },
};

export const usersSearchFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, usersSearchFiltersFields);
};
